<div *ngIf="flashMessages.length > 0" class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 2000;">

  <div *ngFor="let msg of flashMessages"
    class="toast show align-items-center text-white border-0 px-2 d-flex toast-custom" [ngClass]="{
      'bg-success': msg.Type === 'success',
      'bg-danger': msg.Type === 'danger',
      'bg-warning text-dark': msg.Type === 'warning',
      'bg-info': msg.Type === 'info'
    }" (click)="dismiss(msg)">

    <div class="toast-icon px-2 d-flex align-items-center justify-content-center">
      <ng-container [ngSwitch]="msg.Type">
        <i *ngSwitchCase="'success'" class="fa-solid fa-circle-check"></i>
        <i *ngSwitchCase="'danger'" class="fa-solid fa-circle-xmark"></i>
        <i *ngSwitchCase="'warning'" class="fa-solid fa-triangle-exclamation"></i>
        <i *ngSwitchCase="'info'" class="fa-solid fa-circle-info"></i>
      </ng-container>
    </div>
    <div class="toast-body flex-grow-1">
      {{ msg.Message }}
    </div>
  </div>
</div>